/**
 * Tela sempre acesa — sustentação do modo mãos livres.
 *
 * Sem isto o aparelho apaga a tela pelo tempo do sistema e a portaria para até
 * alguém tocar nele, que é exatamente o toque que o modo existe para eliminar.
 *
 * No navegador é a Wake Lock API. O navegador solta a trava sozinho quando a
 * página sai de frente, então ela é pedida de novo na volta — sem isso, a
 * primeira ida ao WhatsApp no meio do evento desligaria o mãos livres em
 * silêncio.
 */

let querAcesa = false;
let trava: WakeLockSentinel | null = null;

async function pedirTrava(): Promise<void> {
  if (!('wakeLock' in navigator) || trava) {
    return;
  }
  try {
    trava = await navigator.wakeLock.request('screen');
    trava.addEventListener('release', () => {
      trava = null;
    });
  } catch (e) {
    console.warn(`[tela] trava de tela recusada: ${e}`);
  }
}

if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (querAcesa && document.visibilityState === 'visible') {
      pedirTrava();
    }
  });
}

/**
 * Nunca lança. Navegador sem a API apenas apaga a tela como sempre — o mãos
 * livres continua validando, e um aviso no log explica por que a tela dormiu.
 */
export function manterTelaAcesa(manter: boolean): void {
  querAcesa = manter;

  if (!('wakeLock' in navigator)) {
    if (manter) {
      console.warn('[tela] navegador sem Wake Lock; a tela vai apagar sozinha');
    }
    return;
  }

  if (manter) {
    pedirTrava();
  } else {
    trava?.release().catch(() => {});
    trava = null;
  }
}
